import { type PayloadAction, createSlice } from '@reduxjs/toolkit'

import { RootState } from 'app/AppStore'
import {sessionApi} from "../../session";

type sliceState = {
  currency: string
  language: string
}

enum LSName {
  currency = 'currency',
  language = 'language',
}

const initialState: sliceState = {
  currency: (localStorage.getItem(LSName.currency) as string) || 'USD',
  language: (localStorage.getItem(LSName.language) as string) || 'EN',
}

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    changeCurrency: (state, action: PayloadAction<string>) => {
      state.currency = action.payload
      localStorage.setItem(LSName.currency, action.payload)
    },
    changeLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload
      localStorage.setItem(LSName.language, action.payload)
    },
  },
  extraReducers: builder => {

    builder.addMatcher(
        sessionApi.endpoints.languages.matchFulfilled,
        (state, { payload }) => {
          const def = payload.find(lang => lang.default)?.code
          const current = localStorage.getItem(LSName.language)
          const isCurrentActive = payload.find(lang => lang.code === current)
          if (!isCurrentActive && def) {
            localStorage.setItem(LSName.language, def)
            state.language = def
          }
          if (def && !localStorage.getItem(LSName.language)) {
            state.language = def
            localStorage.setItem(LSName.language, def)
          }
        }
    )
  }
})

export const selectCurrency = (state: RootState) => state.settings.currency
export const selectLanguage = (state: RootState) => state.settings.language

export const { changeCurrency, changeLanguage } = settingsSlice.actions
